<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%"
    @opened="opened">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <div id="add-container" class="map"></div>
      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

          <el-form-item label="地点名称:" label-width='120px'>
            <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 300px;">
            </el-input>
          </el-form-item>

          <el-form-item label="副标题:" label-width='120px'>
            <el-input v-model="submit_data.keywords" :placeholder="submit_rules.keywords.placeholder"
              style="width: 300px">
            </el-input>
          </el-form-item>

          <el-form-item label="门店照片:" label-width='120px'>

            <!-- <el-input v-model="submit_data.logo_img_url" style="width: 80%;"></el-input> -->
            <el-image v-if="img_url.logo_img_url" :src="img_url.logo_img_url" class="avatar">
            </el-image>
            <el-upload :class="img_url.logo_img_url?'border-none':''" class="avatar-uploader" :action="img_upload_url"
              :show-file-list="false" :on-success="idPortraitSuccess" :before-upload="beforeAvatarUpload"
              :headers="img_headers">
              <el-button slot="trigger" v-if="img_url.logo_img_url" @click="img_url.logo_img_url='';"
                style="width: 100px; margin-top: 10px;">更换图片</el-button>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>


          </el-form-item>




          <el-form-item label="权重:" label-width='120px'>
            <el-input v-model="submit_data.weights" :placeholder="submit_rules.weights.placeholder"
              style="width: 100px">
            </el-input>
          </el-form-item>

          <el-form-item label="状态:" label-width='120px'>
            <el-select v-model="submit_data.status" style="width: 150px; margin-right: 20px;" clearable>
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="置顶:" label-width='120px'>
            <el-select v-model="submit_data.top" style="width: 150px; margin-right: 20px;" clearable>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="开始展示日期:" label-width='120px'>
            <el-date-picker v-model="submit_data.start_time" type="date" placeholder="选择开始时间" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="margin-right: 10px;">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="结束展示日期:" label-width='120px'>
            <el-date-picker v-model="submit_data.end_time" type="date" placeholder="选择结束时间" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="margin-right: 10px;">
            </el-date-picker>
          </el-form-item>


          <el-form-item label="展示时间段:" label-width="120px" v-for="(item, index) in spare_data">

            <el-time-picker v-model="spare_data[index].time_start"
              :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" placeholder="开始时间"
              @change="timeChange($event,'time_start')" value-format="HHmm" format="HH:mm" style="width: 150px;">
            </el-time-picker>

            <span class="el-icon-minus"></span>

            <el-time-picker v-model="spare_data[index].time_end"
              :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" placeholder="结束时间"
              @change="timeChange($event,'time_start')" value-format="HHmm" format="HH:mm" style="width: 150px;">
            </el-time-picker>

          </el-form-item>


          <el-form-item>
            <el-button type="success" icon="el-icon-plus" @click="addSpare">添加时间段</el-button>
          </el-form-item>

          <el-form-item label="备注:" label-width='120px'>
            <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>


        </el-form>





      </template>



    </div>

    <!-- 对话框底部按钮 -->
    <div style="display: flex;justify-content: center;margin-top: 20px;">
<!--      <el-button type="primary" @click="onSubmit">保存</el-button>-->
      <submitBtn @onSubmitDig="onSubmitDig" @toJSON="toJSON" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="true"></submitBtn>
      <el-button @click="closeDialog">关闭</el-button>
    </div>


  </el-drawer>
</template>

<script>
  var _this, map, marker;
  import {
    config
  } from '../../../utils/config'; // 配置
  export default {
    props: {
      'isShow': Boolean,
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        // 获取上传图片的地址
        _this.img_upload_url = config.axios_imgURL;

      },
    },
    data() {
      return {


        show: false,

        spare_data: [{
          time_start: '',
          time_end: ''
        }],



        //压缩质量
        imgQuality: 0.5,
        // 上传图片的请求头
        img_headers: {

          'token': '',
          'hash-key': '',
          'platform': 'pc',
          'app-version': 'admin',
          'port': 'admin',
          'city-tag':localStorage.getItem('city_tag'),
          'service-tag':localStorage.getItem('service_tag')

        },
        // 图片上传地址
        img_upload_url: '',
        //上传图片
        img_url: {

          logo_img_url: '',

        },

        submit_url:'/coordinates/addCoordinatesSubmit',
        // 表单数据
        submit_data: {
          name: '',
          synchronization: '',
          lng: '',
          lat: '',
          logo_img_hash: '',
          keywords: '',
          end_time: '',
          start_time: '',
          top: '',
          weights: '',
          status: '',
          remarks: ''
        },

        submit_rules: {
          name: {
            placeholder: '请输入地址名称',
            rules: {
              required: true,
              message: '地址名称需在50字之内',
              regulation: 'elt_str',
              rulesData: 50
            }
          },
          synchronization: {
            placeholder: '展示时间',
            rules: {
              required: true,
              message: '展示时间',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          lng: {
            placeholder: '点击地图生成坐标点',
            rules: {
              required: true,
              message: '请点击地图生成坐标点',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          lat: {
            placeholder: '点击地图生成坐标点',
            rules: {
              required: true,
              message: '请点击地图生成坐标点',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          logo_img_hash: {
            placeholder: '门店照片',
            rules: {
              required: true,
              message: '门店照片错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          keywords: {
            placeholder: '副标题',
            rules: {
              required: true,
              message: '副标题，200字节之内',
              regulation: 'elt_str',
              rulesData: 200
            }
          },
          end_time: {
            placeholder: '结束展示日期',
            rules: {
              required: true,
              message: '结束展示日期错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          start_time: {
            placeholder: '开始展示日期',
            rules: {
              required: true,
              message: '开始展示日期错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          top: {
            placeholder: '置顶',
            rules: {
              required: true,
              message: '置顶选择错误',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
          weights: {
            placeholder: '权重',
            rules: {
              required: true,
              message: '权重值不能大于10',
              regulation: 'elt',
              rulesData: 9
            }
          },
          status: {
            placeholder: '状态',
            rules: {
              required: true,
              message: '状态选择错误',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
          remarks: {
            placeholder: '备注，200字节之内',
            rules: {
              required: false,
              message: '备注，200字节之内',
              regulation: 'elt_str',
              rulesData: 200
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {
      opened() {
        map = new TMap.Map("add-container", {
          resizeEnable: true,
          zoom: 11,
        });
         _this
            .$post('/admin.php/city/getCityDetails')
                .then((res) => {
                        var center = res.data.center;
                        const [lng, lat] = center.split(',').map(Number);
                        console.log(center);
                        map.setCenter(new TMap.LatLng(lat, lng));

                    // log.success('地图加载完成！');
                })
                .catch((err) => {});
        //为地图注册click事件获取鼠标点击出的经纬度坐标
        map.on("click", function (e) {
          console.log(e);
          if (marker) {
            marker.setGeometries([])
          }
          var lng = e.latLng.lng;
          var lat = e.latLng.lat;
          marker = new TMap.MultiMarker({
              map: map,  //指定地图容器
              //样式定义
              styles: {
                  //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                  "myStyle": new TMap.MarkerStyle({
                      "width": 25,  // 点标记样式宽度（像素）
                      "height": 34, // 点标记样式高度（像素）
                      "src": "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",  //图片路径
                      "offset": { x: -13, y: -30 }
                  })
              },
              //点标记数据数组
              geometries: [{
                  "id": "marker1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                  "styleId": 'myStyle',  //指定样式id
                  "position": new TMap.LatLng(lat, lng),  //点标记坐标位置
                  "properties": {//自定义属性
                      "title": "marker1"
                  }
              }
            ]

          });

          _this.submit_data.lng = lng;
          _this.submit_data.lat = lat;
        });
      },

      // 门店照片上传成功后执行
      idPortraitSuccess(res, file) {

        // 将返回的哈希值存到对应的数组中
        // _this.id_card_portrait_arrway.push(res.data.img_hash);

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.logo_img_hash = res.data.img_hash;

        // 设置img标签显示的图片路径
        _this.img_url.logo_img_url = URL.createObjectURL(file.raw);

      },

      timeChange(val, keyData) {

        for (const key in _this.spare_data) {
          if (key == keyData) {
            _this.spare_data[key] = val;

          }
        }
        console.log(_this.spare_data);


      },

      addSpare() {
        _this.spare_data.push({
          time_start: '',
          time_end: ''
        })
      },



      // 关闭方法
      closeDialog() {
        _this.show = false;
         map.destroy();
        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }
        _this.spare_data = [{
          time_start: '',
          time_end: ''
        }];
      },

      toJSON(){
        for (let i = 0; i < _this.spare_data.length; i++) {

          if (_this.spare_data[i].time_start == '' || _this.spare_data[i].time_end == '') {


            return false;

          }

        }


        _this.submit_data.synchronization = JSON.stringify(_this.spare_data);

      },
      // 提交
      onSubmitDig() {




            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();

      },

      // 图片上传之前执行的函数
      beforeAvatarUpload(file) {

        // 添加请求头
        _this.img_headers.token = localStorage.getItem(config.localStorage_token_name);
        _this.img_headers['hash-key'] = _this.$hash_key();


        return new Promise(resolve => {
          const reader = new FileReader();
          const image = new Image();
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = image.width * _this.imgQuality;
            const height = image.height * _this.imgQuality;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(file.type);
            const blobData = _this.dataURItoBlob(dataUrl, file.type);
            resolve(blobData)
          }
          reader.onload = (e => {
            image.src = e.target.result;
          });
          reader.readAsDataURL(file);
        })
      },
      // 图片压缩方法
      dataURItoBlob(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
          type: type
        });
      },


    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    height: 85vh;
    overflow-y: auto;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .map {
    height: 60%;
    width: 100%;
    margin-bottom: 20px;
  }
</style>